import Framed from '../../src/legacy/Framed.tsx';
export default Framed;
